import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
import { SlotGameType1_2 } from "../SlotGameType1_2";

// import { ResourceManager } from "../../ResourceManager/ResourceManager";
import { FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
// import { SetStyles } from "../.././MyHelpers";
// namespace SlotGames2 {

    export class SevenFeverClassic_2 extends SlotGameType1_2 {
        protected override seconScreenHelpFactory: ISlideFactoryGeneric = new FactoryDoubleSlide();
        // //protected override freegameBonusFactory: FreegameBonusFactory2 = new SevenFever2Freegame2BonusFactory();

        // public PrepareFont(resourceManager: ResourceManager)
		// {
		//  resourceManager.Add(new FontResource(this.basepath + "resources/WildNature.ttf",this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
		// }
    }

    // class SevenFever2Freegame extends FreegameBonus2 {



    //     public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
    //        await super.ResourcesLoaded(resourceManager);

    //         SetStyles(this.view.querySelectorAll(".bonustitle"), {
    //             color: "#FFFFFF",
    //             textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",
    //         });
    //         SetStyles(this.view.querySelectorAll(".total-win"), {
    //             color: "#FFFFFF",
    //             textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",
    //         });
    //         SetStyles(this.view.querySelectorAll("#left"), {
    //             color: "#FFFFFF",
    //             textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",
    //         });
    //         SetStyles(this.view.querySelectorAll("#won"), {
    //             color: "#FFFFFF",
    //             textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",
    //         });
    //         SetStyles(this.view.querySelectorAll("#played"), {
    //             color: "#FFFFFF",
    //             textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",
    //         });
    //         SetStyles(this.view.querySelectorAll(".freegames-num-value"), {
    //             color: "#FFFFFF",
    //             textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",
    //         });
    //         SetStyles(this.view.querySelectorAll(".freegames-left-value"), {
    //             color: "#FFFFFF",
    //             textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",
    //         });
    //     }

    //     protected override OnPlus(session: FreegameSession): void {

    //         if (session == null) {
    //             throw new Error("Session must not be null");

    //         }

    //         if (session.left > this.session.left) {
    //             this.glowRemainig = new TimelineMax(
    //                 {
    //                     onComplete: () => {
    //                         this.elemLeft.style.textShadow = "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px";
    //                     }
    //                 });
    //             this.glowRemainig.add(TweenMax.fromTo(
    //                 this.glow,
    //                 0.25,
    //                 { glow: 0 },
    //                 {
    //                     glow: 100,
    //                     onUpdate: () => {
    //                         this.elemLeft.style.textShadow = "#39FF14 0px 0px 10px, #39FF14 0px 0px 20px, #39FF14 0px 0px 30px, #39FF14 0px 0px 40px"

    //                     }, ease: Power0.easeNone,
    //                 }
    //             ));
    //             this.glowRemainig.add(TweenMax.fromTo(
    //                 this.glow,
    //                 0.25,
    //                 { glow: 100 },
    //                 {
    //                     glow: 0,
    //                     onUpdate: () => {
    //                         this.elemLeft.style.textShadow = "#39FF14 0px 0px 10px, #39FF14 0px 0px 20px, #39FF14 0px 0px 30px, #39FF14 0px 0px 40px"

    //                     },
    //                     ease: Power0.easeNone,
    //                 }
    //             ));

    //             this.titleSprite.Start(false);
    //         }

    //         this.session.Update(session);
    //         this.ApplySession();
    //     }

    // }
    // class SevenFever2Freegame2BonusFactory extends FreegameBonusFactory2 {
    //     public override CreateFreegameBonus2(gameName: ResourceIdentifier, freeGameConfig: FreegameConfiguration, p: FreegameBonus2Params): FreegameBonus2 {
    //         return new SevenFever2Freegame(gameName, freeGameConfig, p);
    //     }
    // }
// }